<template>
  <!-- lazy loading -->
  <v-skeleton-loader v-if="lazy" type="image"></v-skeleton-loader>

  <!-- tool loading -->
  <div v-else-if="!lazy && !dataReady && forceUnLoading"></div>
  <v-overlay v-else-if="!lazy && !dataReady && forceUnLoading!=true">
    <v-progress-circular indeterminate color="purple" size="70" width="7"></v-progress-circular>
  </v-overlay>

  <v-row v-else :no-gutters="embed">
    <!-- 非嵌入模式的参数配置 -->
    <v-col v-if="!embed" cols="4">
      <v-card tile outlined>
        <v-card-title>参数配置
          <v-spacer />
          <v-btn v-for="btn in formButtons" :key="btn.code" @click="btn.click" :color="btn.color||'primary'" :text="btn.text||true" :small="btn.small||true">{{btn.name}}</v-btn>
          <v-btn color="primary" @click="onExport">导出</v-btn>
        </v-card-title>
        <v-card-text>
          <chart-option-form ref="paramForm" :items="tool.params" :coder="tool.coder" @change="onParamFormChanged" />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- chart -->
    <v-col :cols="embed ? 12 :8" class="pa-0">
      <v-row justify="center">
        <v-col cols="auto" class="pa-0">
          <!-- 嵌入模式： 嵌入设置按钮图标 -->
          <div v-if="embed && !noData" class="text-right mr-3 report-hide">
            <v-btn color="primary" class="rounded-0" @click="paramDialogVisible=true" style="z-index:3;" small>图表设置</v-btn>
          </div>
          <div :id="chartElId" :style="chartSizeStyle"></div>
        </v-col>
      </v-row>

      <!-- 未来扩展: 可调整图表大小 -->
      <!-- <div>
        <div :id="chartElId" class="theme--light v-sheet--outlined" :style="chartSizeStyle"></div>
        <v-icon style="float:right;bottom: 24px;cursor: nwse-resize;" :id="`${chartElId}_resizer`">mdi-resize-bottom-right</v-icon>
      </div>
      
      <div :id="`${chartElId}_resizer_shape`" style="display:none;">
        <v-icon style="position: absolute;right: 0;bottom: 0;">mdi-resize-bottom-right</v-icon>
      </div> -->

    </v-col>

    <!-- 插入扩展组件 -->
    <v-col cols="12" v-if="extCPT" class="pa-0">
      <v-row justify="center" no-gutters>
        <v-col cols="auto" class="pa-0">
          <component :style="extCPTSizeStyle" :is="extCPT" v-model="extCPTValue" v-bind="extCPTProps" ref="extCPT" @change="onExtCPTChanged"></component>
        </v-col>
      </v-row>
    </v-col>

    <!-- 嵌入设置对话框 -->
    <template v-if="embed">
      <v-dialog v-model="paramDialogVisible" max-width="400" scrollable>
        <v-card :id="`${chartElId}_paramCard`" max-height="480">
          <v-card-title>
            参数配置
            <v-spacer />
            <v-btn v-for="btn in embedFormButtons" :key="btn.code" @click="btn.click" :color="btn.color||'primary'" :text="btn.text||true" :small="btn.small||true">{{btn.name}}</v-btn>
            <v-btn color="primary" @click="onExport">导出</v-btn>
            <v-icon dark style="position: absolute;right: 4px;margin-bottom: 100px;" @click="paramDialogVisible=false">mdi-close-circle</v-icon>
          </v-card-title>
          <v-card-text>
            <chart-option-form ref="paramForm" :items="tool.params" :coder="tool.coder" @change="onParamFormChanged" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>

    <!-- 导出对话框 -->
    <chart-export-dialog v-model="exportDialogVisible" ref="exportDialog" @ok="onExportOk" />
  </v-row>
</template>
<script>
import ChartOptionForm from '../ChartOptionForm.vue';
import ChartExportDialog from '../ChartExportDialog.vue';
import { userFileRead } from '@/plugins/api';
import { DefaultChartOptions, exportSVG, paramConvert } from '@/plugins/chart';
import ChartOptionBuilder from '@/plugins/ChartOptionBuilder';
let Highcharts = require('highcharts');
Highcharts.setOptions(DefaultChartOptions);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/highcharts-3d')(Highcharts);
require('highcharts/modules/heatmap')(Highcharts);
require('highcharts/modules/networkgraph')(Highcharts);
// require('highcharts/modules/broken-axis')(Highcharts);
export default {
  props: [
    'forceUnLoading', // 是否强制取消loading
    'tool', // type: 图表类型, params:图表参数, coder: 图表参数下拉代码
    'paramValue', // 图表参数值
    'dataSourceParam', // 获取数据源所需参数
    'config', // ChartOptionBuilder所需参数
    'exportFileName',
    'width', 'extWidth', // 图的宽度,扩展组件宽高 (高度不可指定)
    'embed', 'lazy', // 是否嵌入模式, 是否懒加载
    'chartContainerId',
    'formButtons',
    'status' // 图表加载状态
  ],
  data () {
    return {
      dataReady: false,
      noData: true,
      Highcharts: Highcharts,
      extCPT: null,
      extCPTValue: null,
      chart: null,
      paramFormData: {}, // 参数表单数据
      paramOption: null, // 参数转换后的option
      dataSource: null, // 图表数据
      chartOption: {}, // 图表option
      exportDialogVisible: false,
      paramDialogVisible: false, // 嵌入模式: 参数设置对话框是否显示
      paramDialogInit: false
    }
  },
  watch: {
    paramDialogVisible (v) {
      this.onOpenParamDialog(v);
    }
  },
  computed: {
    embedFormButtons () {
      return (!this.formButtons || !this.formButtons.length) ? [] : this.formButtons.filter(b => b.embed);
    },
    chartSizeStyle () { return this.width ? `width:${this.width};` : '' },
    extCPTSizeStyle () { return this.extWidth ? `width:${this.extWidth};` : '' },
    chartElId () { return this.chartContainerId || 'chartContainer' }
  },
  components: { ChartOptionForm, ChartExportDialog },
  async mounted () {
    try {
      await this.init();
    } finally {
      if (this.status) this.status.ready = true;
      // this.initResizer(); 未来扩展: 可调整图表大小
    }
  },
  methods: {
    async init () {
      // console.log('======================================');
      // console.log(this.lazy);
      // console.log(this.tool);
      // console.log(JSON.stringify(this.dataSourceParam));
      // console.log('======================================');
      if (!this.lazy) {
        this.chartOption = {};
        this.paramFormData = {};
        this.paramOption = null;
        this.paramDialogInit = false;
        this.noData = true;

        await this.initData(); // 加载数据
        if (!this.dataSource || !this.dataSource.length) {
          this.dataReady = true;
          this.$nextTick(() => {
            let _chartEl = document.getElementById(this.chartElId)
            if (_chartEl) _chartEl.innerHTML = '<p class="text-h3 orange--text">暂无数据</p>'
          })
        } else {
          this.noData = false;
          await this.initDataAfter(); // 数据加载后处理器
          this.dataReady = true;

          this.$nextTick(async () => {
            this.initParam(); // 初始化参数
            this.initParamAfter(); // 初始化参数后处理器

            this.initParamOption(); // 初始化参数option
            this.initParamOptionAfter(); // 参数option初始化后处理器

            this.initOption(); // 初始化图表option
            this.initOptionAfter(); // 初始化图表option完成后处理器

            // console.log(JSON.stringify(this.chartOption));
            // console.log(this.chartOption);
            await this.initChart(); // 绘制图表
            this.initChartAfter(); // 绘制图表完成后处理器
          })
        }
      }

    },
    async initData () { await userFileRead(this.dataSourceParam).then(res => this.dataSource = res.data) },
    initDataAfter () { },

    initParam () {
      let formData = {};
      this.tool.params.forEach(item => {
        let value = item.dftValue;
        if (value != null && value != '') {
          let type = item.type;
          if (type == 6) value = parseInt(value);
          else if (type == 9) value = (value == 1 || value == 'true')
          formData[item.code] = value
        }
      })
      if (this.paramValue) for (let k in this.paramValue) formData[k] = this.paramValue[k];
      this.paramFormData = formData;
      if (!this.embed) this.$refs.paramForm.setFormData(formData);
    },
    initParamAfter () { },

    initParamOption () {
      let option = {};
      for (let key in this.paramFormData) {
        let item = this.tool.params.find(p => p.code == key);
        let value = paramConvert(key, this.paramFormData[key]);
        if (item && item.optionCode) this.Utility.deepMerge(option, JSON.parse(item.optionCode.replaceAll('\\${value}', value)));
        else this.Utility.deepMerge(option, value);
      }
      this.paramOption = option;
    },
    initParamOptionAfter () { },

    initOption () {
      let defaultChartOption = new ChartOptionBuilder(this.tool.type, this.dataSource, this.config).get();
      this.Utility.deepMerge(this.chartOption, defaultChartOption, this.paramOption);
    },
    initOptionAfter () { },

    initChart () {
      this.chart = Highcharts.chart(this.chartElId, this.chartOption);
    },
    initChartAfter () { },

    onOpenParamDialog (v) {
      if (v) {
        this.$nextTick(() => {
          if (!this.paramDialogInit) {
            this.$refs.paramForm.setFormData(this.paramFormData);
            this.paramDialogInit = true;
          }
          this.Utility.dragDialog(`${this.chartElId}_paramCard`)
        })
      }
    },

    initResizer () {
      let resizer = document.getElementById(`${this.chartElId}_resizer`);
      let resizerShape = document.getElementById(`${this.chartElId}_resizer_shape`);
      let ctc = document.getElementById(this.chartElId);
      resizer.onmousedown = (e) => {
        let width = ctc.offsetWidth, height = ctc.offsetHeight, top = ctc.offsetTop, left = ctc.offsetLeft;
        resizerShape.style = `position:absolute;z-index:100;top:${top}px;left:${left}px;width:${width}px;height:${height}px;background-color:#E0E0E0;opacity:.7;display:block;`;
        let startX = e.clientX, startY = e.clientY;
        document.onmousemove = function (ev) {
          let diffX = startX - ev.clientX, diffY = startY - ev.clientY;
          resizerShape.style.width = (width - diffX) + 'px';
          resizerShape.style.height = (height - diffY) + 'px';
        }
        document.onmouseup = () => {
          ctc.style.width = resizerShape.offsetWidth + 'px';
          ctc.style.height = resizerShape.offsetHeight + 'px';
          ctc.parentElement.style.width = resizerShape.offsetWidth + 'px';
          ctc.parentElement.style.height = resizerShape.offsetHeight + 'px';
          resizerShape.style.display = 'none';
          document.onmousemove = null;
          document.onmouseup = null;
          resizer.releaseCapture && resizer.releaseCapture();
          this.chart.reflow();
        }
        resizer.setCapture && resizer.setCapture();
        return false;
      }
    },
    // ------------------ 导出
    onExport () {
      let svgNode = this.chart.container.children[0];
      let w = svgNode.width.baseVal.value, h = svgNode.height.baseVal.value;
      this.exportDialogVisible = true;
      this.$nextTick(() => this.$refs.exportDialog.setSourceSize({ width: w, height: h }));
    },
    onExportOk (formData) {
      let option = { ...formData, filename: this.exportFileName };
      let svgNode = this.chart.container.children[0];
      exportSVG(svgNode, option);
      this.exportDialogVisible = false;
    },

    // --------------- 图表参数处理
    onParamFormChangedBefore () { },
    onParamFormChanged (e, item) {
      this.paramFormData[item.code] = e;
      let r1 = this.onParamFormChangedBefore(e, item);
      if (r1 === false) return;
      let value = paramConvert(item.code, e);
      let option = value;
      if (item.optionCode) option = JSON.parse(item.optionCode.replaceAll('\\${value}', value));
      this.chart.update(option);
      this.onParamFormChangedAfter(value, item);
    },
    onParamFormChangedAfter () { },

    // --------------- 扩展组件
    onExtCPTChanged () { },

    // ========================== 嵌入式提供函数 ============================
    getSvg () { return this.chart.container.children[0] }

  }
}
</script>
